import React from "react";
import Button from "../../../components/Common/Button/button";
import styles from "../../LKWallet/EmployeeCredit/lkemployeecredit.module.css";
import TableActions from "../../../components/Common/TableActions/tableactions";
import moment from "moment";
import {
  PageHeader,
  Input,
  Row,
  Col,
  Select,
  Form,
  Space,
  Spin,
  // Popconfirm,
  Table,
  Modal,
  // Checkbox,
  notification,
  // DatePicker,
  Upload,
  Tooltip,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import LkCustomBulkNotificationService from "../../../services/lkcustombulknotificationservice";
import { IsAuthenticated } from "../../../services/auth-header";
import UserRightsConfiguration from "../../../shared/userrightsconfiguration";
import { UploadOutlined } from "@ant-design/icons";
import ReactExport from "react-export-excel";
import { labels } from "../../../shared/language";
import Common from "../../../services/common";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const { Search } = Input;
const { Option } = Select;

export default class custombulknotification extends React.Component {
  constructor(props) {
    super(props);
    this.custombulknotificationservice = new LkCustomBulkNotificationService();
    this.UserRightsConfiguration = new UserRightsConfiguration();
    this.common = new Common();
    this.state = {
      modalLoading: false,
      excelFile: <React.Fragment></React.Fragment>,

      lkCustomBulkNotificationItems: [],
      bulkPushFileID: 0,
      exectionDate:"",
      fileName: "",
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
      },
      isEnabled: false,
      isVisible: false,
      loading: true,
      showfilterBox: false,
      showAddPopup: false,

      uploading: false,
      fileList: [],
      binaryFile: "",
      currentURL: "",
    };
  }

  componentWillMount() {
    if (!IsAuthenticated()) {
      window.location.href = "/";
    }
    var data = JSON.parse(localStorage.getItem("userrights"));
    var res = data.filter(
      (val) =>
        val.screenName == this.UserRightsConfiguration.CUSTOM_BULK_NOTIFICATION_UPLOAD
    );
    if (!res[0].isView) {
      window.location.href = "/store/dashboard";
    }
    this.setState({ userRights: res });
  }

  columns = [
    {
      title: labels.FILE_NAME,
      dataIndex: "fileName",
      key: "fileName",
      sorter: true,
    },

    {
      title: labels.DATE_TIME_FOR_EXECUTION,
      dataIndex: "exectionDate",
      key: "exectionDate",
      sorter: true,
      render: (text) => {
        return [null, undefined, ""].includes(text)
          ? ""
          : moment(text).format("DD-MM-YYYY hh:mm:ss a");
      },
    },
    {
      title: labels.TOTAL_RECORDS,
      dataIndex: "totalCnt",
      key: "totalCnt",
      sorter: true,
    },
    {
      title: labels.UPLOADED_BY,
      dataIndex: "createdByName",
      key: "createdByName",
      sorter: true,
    },
    {
      title: labels.UPLOADED_ON,
      dataIndex: "createdOn",
      key: "createdOn",
      sorter: true,
      render: (text) => {
        return [null, undefined, ""].includes(text)
          ? ""
          : moment(text).format("DD-MM-YYYY hh:mm:ss a");
      },
    },
    {
      title: labels.SUCCEEDED,
      dataIndex: "succeeded",
      key: "succeeded",
      sorter: true,
      render: (text, record, index) => {
        return (
          <Space direction="horizontal">
            <span>{text}</span>
            <Tooltip title={labels.DOWNLOAD}>
              <Button
                onClick={() => this.getReport(record.bulkPushFileID, true)}
                type="link"
              >
                <FontAwesomeIcon icon={faDownload} />
              </Button>
            </Tooltip>
          </Space>
        );
      },
    },
    {
      title: labels.FAILED,
      dataIndex: "failed",
      key: "failed",
      sorter: true,
      render: (text, record, index) => {
        return (
          <Space direction="horizontal">
            <span>{text}</span>
            <Tooltip title={labels.DOWNLOAD}>
              <Button
                onClick={() => this.getReport(record.bulkPushFileID, false)}
                type="link"
              >
                <FontAwesomeIcon icon={faDownload} />
              </Button>
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  componentDidMount() {
    const { pagination } = this.state;
    this.fetchItems({
      bulkPushFileID: this.state.bulkPushFileID,
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
      pagination,
    });
  }

  handleSearch = (event) => {
    this.fetchItems({
      bulkPushFileID: this.state.bulkPushFileID,
      commonSearch: event.target.value,
      pageIndex: this.state.pagination.current,
      pageSize: this.state.pagination.pageSize,
      pagination: this.state.pagination,
      // ...filters,
    });
  };

  getReport = (id, type) => {
    this.custombulknotificationservice
      .getReport({
        bulkPushFileID: parseInt(id),
        isSucceeded: type,
      })
      .then((response) => {
        this.setState(
          {
            excelFile: (
              <div>
                <ExcelFile
                  hideElement={true}
                  filename={type ? "succeeded" : "failed"}
                >
                  <ExcelSheet
                    data={response.data}
                    name={type ? "Succeeded Records" : "Failed Records"}
                    columns={[]}
                  >
                    <ExcelColumn label="Customer Name" value="customerName" />
                    <ExcelColumn label="MobileNo" value="mobileNo" />
                    <ExcelColumn label="Title" value="title" /> 
                    <ExcelColumn label="Description" value="description" /> 
                    <ExcelColumn label="CreatedBy Name" value="createdByName" />
                    <ExcelColumn label="Created On" value="createdOn" />
                    <ExcelColumn label="ExecutionDateTime" value="executionDateTime" />
                    <ExcelColumn label="Admin Remark" value="adminRemark" />
                    <ExcelColumn label="Remarks" value="remark" />
                  </ExcelSheet>
                </ExcelFile>
              </div>
            ),
          },
          () => this.setState({ excelFile: <React.Fragment></React.Fragment> })
        );
      });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.fetchItems({
      bulkPushFileID: 0,
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
      pagination,
      sortColumn: sorter.field,
      sortOrder:
        sorter.order === "ascend"
          ? "asc"
          : sorter.order === "descend"
          ? "desc"
          : sorter.order,
      // ...filters,
    });
  };

  handlePopupOk = () => {
    this.setState({ showAddPopup: false });
  };

  handlePopupCancel = () => {
    this.setState({ showAddPopup: false });
    this.resetFields();
  };

  fetchItems = (params = {}) => {
    this.setState({ loading: true });
    this.custombulknotificationservice
      .getcustomebulknotificationdata(params)
      .then((items) => {
        if (items.statusCode === 200) {
          if (
            items.length !== 0 &&
            items.data.length === 0 &&
            params.pagination.current !== 1
          ) {
            params.pagination.current = 1;
            this.fetchItems({
              bulkPushFileID: 0,
              pageIndex: 1,
              pageSize: params.pageSize,
              pagination: params.pagination,
            });
          }
          this.setState({
            lkCustomBulkNotificationItems: items.data,
            pagination: {
              ...params.pagination,
              total:
                items.length !== 0 && items.data.length !== 0
                  ? items.data[0].totalRecords
                  : 0,
            },
          });
        } else {
          notification["error"]({
            message: labels.CUSTOMER_BULK_CREDIT,
            description: items.message
              ? this.common.Message(items.message)
              : labels.UNABLE_TO_GET_LIST_OF_CUSTOM_BULK_NOTIFICATION_DATA,
          });
        }
        this.setState({ loading: false });
      });
  };

  handleUpload = (values) => {
    this.setState({ modalLoading: true });
    let postData = new FormData();
    postData.append("CustomerBulkNotiFile", values.file[0].originFileObj);
    this.custombulknotificationservice.uploadFile(postData).then((response) => {
      if (response.statusCode === 200) {
        notification["success"]({
          message: labels.CUSTOMER_BULK_CREDIT,
          description: this.common.Message(response.message),
        });
        this.fetchItems({
          pageIndex: this.state.pagination.current,
          pageSize: this.state.pagination.pageSize,
          ...this.state.pagination,
        });
      } else {
        notification["error"]({
          message: labels.CUSTOMER_BULK_CREDIT,
          description: response.message
            ? this.common.Message(response.message)
            : labels.UNABLE_TO_UPLOAD_THE_FILE,
        });
      }
      this.setState({ modalLoading: false });
    });
    this.setState({ showAddPopup: false });
  };

  handleBonusAmount = (e) => {
    this.setState({ bonusAmount: e.target.value });
  };

  handleDateChange = (date, name) => {
    this.setState({ [name]: date });
  };

  handleRemark = (e) => {
    this.setState({ remark: e.target.value });
  };

  resetFields = () => {
    this.setState({
      bulkPushFileID: 0,
      fileName: "",
      exectionDate:"",
      totalCnt: "",
      succeeded: "",
      failed: "",
      isEnabled: false,
      isVisible: false,
    });
  };
  

  render() {
    const {
      fileName,
      exectionDate,
      totalCnt,
      succeeded,
      failed,
      pagination,
      loading,
      remark,
    } = this.state;
    const lkCustomBulkNotificationItems = this.state.lkCustomBulkNotificationItems;
    let RegexInteger = /^[1-9]+[0-9]*$/g;
    const listItems = lkCustomBulkNotificationItems.map((item, index) => ({
      key: item.bulkPushFileID,
      bulkPushFileID: item.bulkPushFileID,
      exectionDate:item.exectionDate,
      fileName: item.fileName,
      totalCnt: item.totalCnt,
      succeeded: item.succeeded,
      failed: item.failed,
      totalRecords: item.totalRecords,
      createdBy: item.createdBy,
      createdByName: item.createdByName,
      createdOn: item.createdOn,
    }));
    return (
      <div>
         {this.state.excelFile}
        <PageHeader
          title={labels.CUSTOM_BULK_NOTIFICATION_UPLOAD}
          extra={[
            <Search
              placeholder={labels.SEARCH}
              className={styles.SearchInput}
              onChange={this.handleSearch}
              key="1"
            />,
            <a
              href={window.location.origin + "/files/CustomerBulkPushNotification.xls"}
              key="4"
              style={{ alignSelf: "center" }}
            >
              {labels.DOWNLOAD_FORMAT}
            </a>,
            this.state.userRights.length > 0 &&
            this.state.userRights[0].isAdd == true ? (
              <Button
                variant="purple"
                htmlType="submit"
                onClick={() => this.setState({ showAddPopup: true })}
                key="2"
              >
                {labels.UPLOAD_FILE}
              </Button>
            ) : null,
          ]}
        />
        <Table
          size="small"
          columns={this.columns}
            dataSource={listItems}
            pagination={pagination}
            loading={loading}
            onChange={this.handleTableChange}
        />
        <TableActions isPagination={true}></TableActions>
        <Modal
          title={
            this.state.bulkPushFileID === 0
              ? labels.ADD_CUSTOM_BULK_NOTIFICATION
              : this.state.isEnabled
              ? labels.VIEW_CUSTOM_BULK_NOTIFICATION
              : labels.EDIT_CUSTOM_BULK_NOTIFICATION
          }
          visible={this.state.showAddPopup}
          footer={null}
          onCancel={this.handlePopupCancel}
          className="modal-form"
          destroyOnClose
        >
          <Spin spinning={this.state.modalLoading}>
            <Form
              layout="vertical"
              onFinish={this.handleUpload}
              initialValues={{
                fileName,
                exectionDate,
                totalCnt,
                succeeded,
                failed,
              }}
            >
              <Row gutter={24}>
                <Col xs={24}>
                  <Form.Item
                    name="file"
                    label={
                      labels.UPLOAD_CUSTOM_BULK_NOTIFICATION_CONFIGURATION_FILE
                    }
                    rules={[
                      { required: true, message: labels.PLEASE_SELECT_FILE },
                    ]}
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e;
                      }
                      return e && e.fileList;
                    }}
                  >
                    <Upload
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xls"
                      customRequest={({ onSuccess }) => {
                        setTimeout(() => {
                          onSuccess("ok");
                        }, 0);
                      }}
                    >
                      <Button variant="transparentGreyOutline">
                        <UploadOutlined /> {labels.CLICK_TO_UPLOAD}
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>

                <Col xs={24} className="custom-modal-footer">
                  <Space>
                    {this.state.isVisible ? (
                      <>
                        <Button
                          variant="transparentGreyOutline"
                          onClick={this.handlePopupCancel}
                        >
                          {labels.CANCEL}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="transparentGreyOutline"
                          onClick={this.handlePopupCancel}
                        >
                          {labels.CANCEL}
                        </Button>
                        <Button htmlType="submit" variant="purple">
                          {this.state.bulkPushFileID === 0
                            ? labels.ADD
                            : labels.UPDATE}
                        </Button>
                      </>
                    )}
                  </Space>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Modal>
      </div>
    );
  }
}
